import React from 'react';
import { ZapIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function StickyOfferBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'TIM'
  }, {
    value: minutes,
    label: 'MIN'
  }, {
    value: seconds,
    label: 'SEK'
  }];
  return <div className="fixed inset-x-0 top-0 z-50 border-b border-navy/20 bg-navy text-cream" data-id="element-202" data-mp="2k7uwfwgvl7bd">
      <div className="mx-auto flex w-full max-w-6xl flex-wrap items-center justify-center gap-x-4 gap-y-1 px-5 py-2.5 sm:px-8" data-id="element-203" data-mp="2facoo9elgy4y">
        <p className="flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.14em] text-gold sm:text-xs" data-id="element-204" data-mp="2ackwdea1fa08">
          <ZapIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-205" data-mp="219s7fhobvadk" />
          Lanseringserbjudande slutar om:
        </p>

        <p className="flex items-center gap-1.5 font-serif text-xl leading-none tabular-nums sm:text-2xl" data-id="element-206" data-mp="4hrzw7auxryc">
          {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-207" data-mp="3vlqcd7fltk3n" data-mpi={index}>
              {index > 0 && <span aria-hidden="true" className="text-gold/70" data-id="element-208" data-mp="ondxtbb79flh">
                  :
                </span>}
              <span className="flex items-baseline gap-1" data-id="element-209" data-mp="tlns7jp3oc61">
                {unit.value}
                <span className="font-sans text-[9px] font-bold uppercase tracking-[0.16em] text-cream/70" data-id="element-210" data-mp="fqbynfmokrqp">
                  {unit.label}
                </span>
              </span>
            </React.Fragment>)}
        </p>
      </div>
    </div>;
}